import { performCallAllIns } from "../../../../network/protocol/gameServer";
import { GameServerMessage } from "../../../../network/protocol/gameServer/types";
import MessagesCommunication from "../../../app/sagas/shared/messagesCommunication";

export default function callAllIns(
  connection: MessagesCommunication<GameServerMessage>,
) {
  connection.send(performCallAllIns());
}
